var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.url)?_c('vl-layer-vector',{attrs:{"overlay":""}},[_c('vl-source-vector',{attrs:{"url":_vm.url}}),_c('vl-style-func',{attrs:{"factory":_vm.style}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }